import { createContext, useContext } from 'react';
interface ISidebarHelpProps {
	states: any;
	setters: any;
}
export const SidebarHelpContext = createContext({} as ISidebarHelpProps);

export default function useSidebarHelp() {
	return useContext(SidebarHelpContext);
}
